// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".readable .q-field__inner[data-v-36f48588]:hover:after{position:absolute;top:-30%;left:70%;width:-webkit-fit-content;width:-moz-fit-content;width:fit-content;content:\"\";background-color:#fff;color:#000;line-height:0;border:0 solid #000;box-shadow:2px 2px 10px #999;border-radius:0;padding:2px}.col-md-12[data-v-36f48588]{padding-left:0!important;padding-right:0!important}", ""]);
// Exports
module.exports = exports;
